module.exports = __webpack_public_path__ + "static/media/HomePagePlus_72dpi.be71704e.png";